var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  color: "#525252"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.01666667 7.4916667C5.21666667 9.85 7.15 11.775 9.50833333 12.9833333L11.3416667 11.15c.225-.225.5583333-.3.85-.2.9333333.3083333 1.9416666.475 2.975.475C15.625 11.425 16 11.8 16 12.2583333v2.9083334C16 15.625 15.625 16 15.1666667 16 7.34166667 16 1 9.6583333 1 1.8333333 1 1.375 1.375 1 1.83333333 1H4.75c.45833333 0 .83333333.375.83333333.8333333 0 1.0416667.16666667 2.0416667.475 2.975C6.15 5.1 6.08333333 5.425 5.85 5.6583333L4.01666667 7.4916667z",
  fillRule: "nonzero",
  stroke: "currentColor",
  strokeWidth: .84999996,
  fill: "none"
})));
export default __webpack_public_path__ + "static/media/phone.89b2514b.svg";
export { SvgComponent as ReactComponent };